<template>
  <div>
    <v-container fluid class="py-6">
      <div class="d-sm-flex justify-between">
        <v-btn
            v-if="false"
            @click="$router.go(-1)"
            elevation="0"
            outlined
            :ripple="false"
            height="43"
            class="
            font-weight-bold
            text-uppercase
            btn-default
            py-2
            px-6
            me-2
            mb-sm-0 mb-2
          "
            color="#5e72e4"
            small
        >
          <v-icon size="16">fas fa-arrow-left me-1</v-icon>
          ADD BATCH
        </v-btn>
        <div class="d-flex ms-auto">
          <v-menu transition="slide-y-transition" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                  font-weight-bold
                  text-uppercase
                  btn-default btn-outline-default
                  py-2
                  px-6
                  me-2
                "
                  color="transparent"
                  small
              >
                Filter By - {{ (filterString).toUpperCase() }}
                <v-icon>ni ni-bold-down text-xs ms-1</v-icon>
              </v-btn>
            </template>
            <v-list class="py-0">
              <v-list-item @click="filterString = 'Active', getCompanies('Active')" class="list-item-hover-active py-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Status: Active
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="filterString = 'First Reminder', getCompanies('First Reminder')" class="list-item-hover-active pb-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Status: First Reminder
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <hr class="horizontal dark" />
              <v-list-item @click="filterString = 'Second Reminder', getCompanies('Second Reminder')" class="list-item-hover-active pb-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Status: Second Reminder
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <hr class="horizontal dark" />
              <v-list-item @click="filterString = 'Cancelled', getCompanies('Cancelled')" class="list-item-hover-active pb-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Status: Cancelled
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <hr class="horizontal dark" />
              <v-list-item @click="filterString = 'all', getCompanies('all')" class="list-item-hover-active py-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-danger ls-0 font-weight-600 mb-0"
                  >
                    Remove Filter
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
      <v-row v-if="selected.length > 0">
        <v-col sm="3" cols="12" >
          <v-select
              label="Select Action"
              :items="['Rodwell Muchunga', 'Tinashe Ncube', 'Abel Timba']"
          ></v-select>
        </v-col>
        <v-col sm="3" cols="12">
          <v-btn
              elevation="0"
              :ripple="false"
              height="43"
              class="
            font-weight-bold
            text-uppercase
            btn-default
            bg-gradient-success
            py-2
            mt-2
            px-6
            me-2
            mb-sm-0 mb-2
          "
              color="#5e72e4"
              small
          >
            <v-icon size="16">fas fa-thumbs-up me-1</v-icon>
            ASSIGN</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card class="card-shadow border-radius-xl">
            <div>
              <v-card class="card-shadow border-radius-xl mt-6">
                <v-card-text class="px-0 py-0">
                  <v-data-table
                      :headers="headers"
                      :items="organisation"
                      :search="search"
                      class="table"
                      :page.sync="page"
                      hide-default-footer
                      @page-count="pageCount = $event"
                      :items-per-page="itemsPerPage"
                      mobile-breakpoint="0"
                      v-model="selected"
                      show-select
                  >
                    <template v-slot:top>
                      <v-toolbar flat height="80">
                        <v-row>
                          <v-col cols="12" md="5">
                            <v-text-field
                                hide-details
                                class="
                                      input-style
                                      font-size-input
                                      text-light-input
                                      placeholder-light
                                      input-icon
                                    "
                                dense
                                flat
                                filled
                                solo
                                height="43"
                                v-model="search"
                                placeholder="Search"
                            >
                              <template slot="prepend-inner">
                                <v-icon color="#adb5bd" size=".875rem"
                                >fas fa-search</v-icon
                                >
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="12" md="5">
                            <template>
                              <v-btn
                                  @click="createExcel()"
                                  v-if="organisation.length > 0"
                                  elevation="0"
                                  outlined
                                  :ripple="false"
                                  height="43"
                                  class="
                                          font-weight-bold
                                          text-uppercase
                                          btn-default
                                          text-color-light
                                          bg-gradient-secondary
                                          py-2
                                          px-6
                                          me-2
                                          mb-sm-0 mb-2
                                        "
                                  color="#5e72e4"
                                  small
                              >
                                <v-icon size="16">fas fa-download me-1</v-icon>
                                Download {{ filterString }} companies
                              </v-btn>
                            </template>
                          </v-col>
                        </v-row>
                      </v-toolbar>
                    </template>

                    <template v-slot:item.id="{ item }">
                      <div class="d-flex align-center">
                        <v-checkbox
                            :ripple="false"
                            v-model="item.checkbox"
                            color="#141727"
                        ></v-checkbox>
                        <span class="my-2 text-xs text-body font-weight-bold">{{
                            item.id
                          }}</span>
                      </div>
                    </template>

                    <template v-slot:item.created_at="{ item }">
                    <span class="my-2 text-xs text-body font-weight-bold">{{
                        new Date(item.created_at).toLocaleString()
                      }}
                    </span>
                    </template>

                    <template v-slot:item.status="{ item }">
                      <div class="d-flex align-center">
                        <v-btn
                            :ripple="false"
                            icon
                            outlined
                            rounded
                            width="25px"
                            height="25px"
                            class="me-2"
                            :class="
                            item.status == 'active' || item.status == 'Active' ? 'border-success' : 'border-warning'">
                          <v-icon
                              size="8"
                              :class="
                            item.status == 'active' || item.status == 'Active' ? 'text-success'
                              : 'text-warning'
                          "
                          >
                            fas fa-check
                          </v-icon>
                        </v-btn>
                        <span class="text-body text-xs">{{ item.status }}</span>
                      </div>
                    </template>

                    <template v-slot:item.is_verified="{ item }">
                      <div class="d-flex align-center">
                        <v-btn
                            :ripple="false"
                            icon
                            outlined
                            rounded
                            width="25px"
                            height="25px"
                            class="me-2"
                            :class="
                  item.is_verified == true
                    ? 'border-success'
                    : 'border-warning'
                "
                        >
                          <v-icon
                              size="8"
                              :class="
                    item.is_verified == true
                      ? 'text-success'
                      : 'text-warning'
                  "
                          >
                            fas fa-check
                          </v-icon>
                        </v-btn>
                        <span class="text-body text-xs">{{ item.is_verified == true
                            ? 'Verified'
                            : 'Pending' }}</span>
                      </div>
                    </template>

                    <template v-slot:item.trading_as="{ item }">
                      <div class="d-flex align-center">
                        <v-avatar size="24" class="me-2 bg-gradient-default">
                          <span class="text-white text-xs">{{ item.trading_as[0] }}</span>
                        </v-avatar>
                        <span class="text-body text-xs font-weight-bold">{{
                            item.trading_as
                          }}</span>
                      </div>
                    </template>

                    <template v-slot:item.product="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.product
              }}</span>
                    </template>

                    <template v-slot:item.revenue="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.revenue
              }}</span>
                    </template>

                    <template v-slot:item.action="{ item }">
                      <v-btn
                          @click="goTo(item)"
                          elevation="0"
                          small
                          :ripple="false"
                          height="21"
                          class="
                    border-radius-sm
                    font-weight-bolder
                    px-2
                    py-2
                    badge-font-size
                    ms-auto
                    text-white text-xxs
                    mb-2
                  "
                          :class="
                    item.is_active
                      ? 'bg-gradient-success'
                      : 'bg-gradient-warning'
                  "
                      >View</v-btn
                      >
                      &nbsp; &nbsp;
                      <v-btn
                          @click="selectRecord(item)"
                          elevation="0"
                          small
                          :ripple="false"
                          height="21"
                          class="
                                border-radius-sm
                                font-weight-bolder
                                px-2
                                py-2
                                badge-font-size
                                ms-auto
                                text-white text-xxs
                                mb-2
                              "
                          :class="
                          item.is_active
                            ? 'bg-gradient-success'
                            : 'bg-gradient-warning'
                           "
                            >Edit</v-btn
                            >
                    </template>

                    <template v-slot:item.invoice="{ item }">
                      <v-btn
                          color="#fff"
                          class="text-dark font-weight-bolder px-1 shadow-0"
                          small
                          simple
                      >
                        <v-icon size="18" class="rotate-180"
                        >fas fa-file-pdf text-lg me-1</v-icon
                        >
                        Pdf
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions class="card-padding">
                  <v-row>
                    <v-col cols="6" lg="3" class="d-flex align-center">
                      <span class="text-body me-3 text-sm">Items per page:</span>
                      <v-text-field
                          hide-details
                          type="number"
                          outlined
                          min="-1"
                          max="15"
                          background-color="rgba(255,255,255,.9)"
                          color="rgba(0,0,0,.6)"
                          light
                          :value="itemsPerPage"
                          @input="itemsPerPage = parseInt($event, 10)"
                          placeholder="Items per page"
                          class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
              "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="6" class="ml-auto d-flex justify-end">
                      <v-pagination
                          prev-icon="fa fa-angle-left"
                          next-icon="fa fa-angle-right"
                          class="pagination"
                          color="#cb0c9f"
                          v-model="page"
                          :length="pageCount"
                          circle
                      ></v-pagination>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="companyDialog"
              persistent
              max-width="600px"
          >
            <v-card>
              <v-card-title>
                <span class="text-h5">Company Profile Edit</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                        cols="12"
                        sm="12"
                        md="12"
                    >
                      <v-text-field
                          :disabled="true"
                          hide-details
                          class="
                                  input-style
                                  font-size-input
                                  text-light-input
                                  placeholder-light
                                  input-icon
                                "
                          dense
                          flat
                          filled
                          solo
                          height="43"
                          v-model="selectedRecord.trading_as"
                          placeholder="Company Name"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="12"
                        md="12"
                    >
                      <v-text-field
                          hide-details
                          class="
                                  input-style
                                  font-size-input
                                  text-light-input
                                  placeholder-light
                                  input-icon
                                "
                          dense
                          flat
                          filled
                          solo
                          height="43"
                          v-model="selectedRecord.business_address"
                          placeholder="Company Address"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="6"
                    >
                      <v-text-field
                          hide-details
                          class="
                                  input-style
                                  font-size-input
                                  text-light-input
                                  placeholder-light
                                  input-icon
                                "
                          dense
                          flat
                          filled
                          solo
                          height="43"
                          v-model="selectedRecord.company_registration"
                          placeholder="Account Number"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="6"
                    >
                      <v-text-field
                          hide-details
                          class="
                                  input-style
                                  font-size-input
                                  text-light-input
                                  placeholder-light
                                  input-icon
                                "
                          dense
                          flat
                          filled
                          solo
                          height="43"
                          v-model="selectedRecord.contact_name"
                          placeholder="Contact Name"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="6"
                    >
                      <v-text-field
                          hide-details
                          class="
                                  input-style
                                  font-size-input
                                  text-light-input
                                  placeholder-light
                                  input-icon
                                "
                          dense
                          flat
                          filled
                          solo
                          height="43"
                          v-model="selectedRecord.email"
                          placeholder="Contact Email"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="6"
                    >
                      <v-text-field
                          hide-details
                          class="
                                  input-style
                                  font-size-input
                                  text-light-input
                                  placeholder-light
                                  input-icon
                                "
                          dense
                          flat
                          filled
                          solo
                          height="43"
                          v-model="selectedRecord.telephone"
                          placeholder="Contact Number"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col
                          cols="12"
                          sm="6"
                          md="6"
                      >
                        <v-text-field
                            hide-details
                            class="
                                  input-style
                                  font-size-input
                                  text-light-input
                                  placeholder-light
                                  input-icon
                                "
                            dense
                            flat
                            filled
                            solo
                            height="43"
                            v-model="selectedRecord.officer"
                            placeholder="Designated Officer"
                            required
                        ></v-text-field>
                      </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="6"
                    >
                    <v-select
                        :items="[{text: 'Active', value: true}, {text: 'Inactive', value: false}]"
                        v-model="selectedRecord.is_active"
                        item-text="text"
                        item-value="value"
                        color="rgba(0,0,0,.6)"
                        class="
                              input-style
                              font-size-input
                              text-light-input
                              placeholder-light
                              border-radius-md
                              select-style
                              mt-2
                              mb-0
                            "
                        outlined
                        single-line
                        height="38"
                    >
                    </v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    outlined
                    @click="companyDialog = false"
                >
                  Close
                </v-btn>
                <v-btn
                    color="green darken-1"
                    outlined
                    @click="updateCompany()"
                >
                  Update
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
              v-model="successDialog"
              max-width="290"
              persistent
          >
            <v-card class="text-center ">
              <v-card-title class="text-h5 justify-center">
                Success
              </v-card-title>

              <v-card-text>
                Your edit has been done
              </v-card-text>

              <v-card-actions class="justify-center">
                <v-btn
                    color="green darken-1"
                    text
                    outlined
                    @click="successDialog = false"
                >
                  Continue
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <div class="text-center">
        <v-overlay :value="overlay">
          <v-progress-circular
              indeterminate
              size="64"
          />
        </v-overlay>
      </div>
    </v-container>
  </div>
</template>
<script>

import axios from "axios";
import {mapState} from "vuex";
import ledgerDownload from "@/views/Client/Orders/LedgerDownload.vue";
import moment from "moment";
import * as xlsx from "xlsx";

export default {
  name: "organisation-List",
  data() {
    return {
      overlay: false,
      successDialog: false,
      companyDialog: false,
      selectedRecord: {},
      filterString: "all",
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      organisation: [],
      selected: [],
      search: "",
      headers: [
        {
          text: "Company",
          value: "trading_as",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "ADDRESS",
          value: "business_address",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Status",
          value: "status",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Date Created",
          value: "created_at",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Action",
          value: "action",
          class: "text-secondary font-weight-bolder opacity-7",
        },

      ],
    };
  },
  created () {
    this.getCompanies(this.filterString)
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  computed: {
    ledgerDownload() {
      return ledgerDownload
    },
    ...mapState(['base_url']),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    pages() {
      return this.pagination.rowsPerPage
          ? Math.ceil(this.items.length / this.pagination.rowsPerPage)
          : 0;
    },
  },
  methods: {
    getCompanies(){
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/auth/get-organisations/' + this.filterString, { headers: { Authorization: `Bearer ${JWTToken}` } } )
          .then(res => {
            if (res.status === 200) {
              this.organisation = res.data
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },
    updateCompany(){
      this.overlay = true
      const JWTToken = this.$store.getters.accessToken
      axios.patch(this.base_url + '/auth/update-organisation/' + this.selectedRecord.id, this.selectedRecord, { headers: { Authorization: `Bearer ${JWTToken}` } } )
          .then(res => {
            if (res.status === 200) {
              this.getCompanies()
              this.companyDialog = false
              this.selectedRecord = {}
              this.overlay = false
              this.successDialog = true
            } else if (res.status === 202) {
              console.log('202')
              this.overlay = false
            } else {
              console.log('error')
              this.overlay = false
            }
          })
    },
    goTo(item){
      this.$router.push({
        name: "Approve Organisation",
        params: { id: item.id },
        query: { id: item.id , },
      });
    },
    async createExcel() {
      const filename = String('Companies - ' + moment(Date()).format('MM/DD/YYYY') + '.xlsx')
      const data = this.organisation
      const ws = xlsx.utils.json_to_sheet(data);
      const wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, 'BatchSummary')
      xlsx.writeFile(wb, filename)
    },
    selectRecord(record) {
      this.selectedRecord = { ...record };
      this.companyDialog = true
    }
  },
};
</script>
